import { Tooltip } from 'antd';
import dayjs, { type ConfigType } from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import React from 'react';

import { EDateFormat } from '../fragments/date-format';

dayjs.extend(relativeTime);

function RelativeTime({ value }: { value: ConfigType }): React.ReactElement {
  return (
    <Tooltip title={dayjs(value).format(EDateFormat.DATE_TIME)}>
      <span>{dayjs(value).fromNow()}</span>
    </Tooltip>
  );
}

export default RelativeTime;
